import styled from 'styled-components';

export const Content = styled.main`
  margin: 0 auto;
  max-width: 650px;
  padding: 40px 20px;
`;
